import i18n from "@/common/i18n";
import Layout from '@/layout/index';
const router = [{
  path: '/material',
  component: Layout,
  redirect: '/material/word',
  meta: {
    auth: true,
    title: `${i18n.t("lang.k_017001")}`,
    name: 'Material',
    icon: 'saasicon_datas_img',
    level: 1
  },
  children: [{
    path: 'word',
    component: () => import('@/views/MaterialModule/word'),
    meta: {
      auth: true,
      title: `${i18n.t("lang.k_017002")}`,
      name: 'wordMgr'
    }
  }, {
    path: 'video',
    component: () => import('@/views/MaterialModule/video'),
    meta: {
      auth: true,
      title: `${i18n.t("lang.k_017003")}`,
      name: 'videoMgr'
    }
  }]
}];
export default router;